module.exports = __webpack_public_path__ + "img/36.79ddfd1a.jpg";